class News {
    _id;
    _userId;
    _addressId;

    _title;
    _body;
    _photo;
    _thumbnail;

    _newsTimestamp;
    _translations;
    _created;
    _modified;

    constructor(id, userId, addressId, title, body, thumbnail, newsTimestamp, created, modified, translations) {
        this._id = id;
        this._userId = userId;
        this._addressId = addressId;
        this._title = title;
        this._body = body;
        this._thumbnail = thumbnail;
        this._newsTimestamp = newsTimestamp;
        this._created = created;
        this._modified = modified;
        this._translations = translations;
    }

    setId(newId) {
        this._id = newId;
    }
    get id() {
        return this._id;
    }

    setUserId(newUserId) {
        this._userId = newUserId;
    }
    get userId() {
        return this._userId;
    }

    setAddressId(newAddressId) {
        this._addressId = newAddressId;
    }
    get addressId() {
        return this._addressId;
    }

    setTitle(newTitle) {
        this._title = newTitle;
    }
    get title() {
        return this._title;
    }

    setBody(newBody) {
        this._body = newBody;
    }
    get body() {
        return this._body;
    }

    setPhoto(newPhoto) {
        this._photo = newPhoto;
    }
    get photo() {
        return this._photo;
    }

    setThumbnail(newThumbnail) {
        this._thumbnail = newThumbnail;
    }
    get thumbnail() {
        return this._thumbnail;
    }

    setNewsTimestamp(newTimestamp) {
        this._newsTimestamp = newTimestamp;
    }
    get newsTimestamp() {
        return this._newsTimestamp
    }

    setCreated(newTimestamp) {
        this._created = newTimestamp;
    }
    get created() {
        return this._created;
    }

    setModified(newTimestamp) {
        this._modified = newTimestamp;
    }
    get modified() {
        return this._modified
    }
    setTranslations(newTranslations) {
        this._translations = newTranslations;
    }
    get translations() {
        return this._translations;
    }
}

export default News;
